import React from 'react';

import { Alert, Text, CloseIcon, HStack, IconButton, VStack } from 'native-base';

interface CustomAlertBannerProps {
    isVisible: boolean;
    title: string;
    status: string;
}

export default function CustomAlertBanner(props: CustomAlertBannerProps) {

    const [isOpen, setIsOpen] = React.useState(props.isVisible);

    React.useEffect(() => {
        setIsOpen(props.isVisible);
    }, [props.isVisible]);

    return <>
        {isOpen && <Alert w="100%" status={props.status}>
            <VStack space={2} flexShrink={1} w="100%">
                <HStack flexShrink={1} space={2} justifyContent="space-between">
                    <HStack space={2} flexShrink={1}>
                        <Alert.Icon mt="1" />
                        <Text fontSize="md" color="coolGray.800">
                            {props.title}
                        </Text>
                    </HStack>
                    <IconButton
                        variant="unstyled"
                        onPress={() => setIsOpen(false)}
                        _focus={{
                            borderWidth: 0
                        }} icon={<CloseIcon size="3" />} _icon={{
                            color: "coolGray.600"
                        }} />
                </HStack>
            </VStack>
        </Alert>}
    </>
};